import React from 'react';
import PropTypes from 'prop-types';
import { Button, Div, Icon, Text } from '@pinpoint/design-kit';

import CONSTANTS from 'src/store/constants';

function selectedTextColor(selected) {
  return selected ? 'white' : 'lightGrey';
}

function selectedBgColor(selected, color) {
  return selected ? color : 'transparent';
}

function selectedActiveBgColor(selected, color) {
  return selected ? 'white' : color;
}

function selectedIsLoading(selected, apiStatus) {
  return selected && apiStatus === CONSTANTS.API.STARTED;
}

function StatusFilterButton({ color, text, selected, apiStatus, ...rest }) {
  return (
    <Button
      d="inline-flex"
      rounded="sm"
      textColor={selectedTextColor(selected)}
      bg={selectedBgColor(selected, color)}
      h="1.7rem"
      p={{ x: '0.75rem', y: '0rem' }}
      m={{ l: '.625rem' }}
      {...rest}
    >
      {apiStatus && selectedIsLoading(selected, apiStatus) ? (
        <Icon d="block" m="0 auto" size=".9rem" color="white" name="Loading" />
      ) : (
        <Div rounded="sm" bg={selectedActiveBgColor(selected, color)} h=".9rem" w=".9rem" />
      )}
      <Text m={{ l: '.5rem' }}>{text}</Text>
    </Button>
  );
}

StatusFilterButton.defaultProps = {
  apiStatus: '',
};

StatusFilterButton.propTypes = {
  color: PropTypes.string.isRequired,
  text: PropTypes.string.isRequired,
  selected: PropTypes.bool.isRequired,
  apiStatus: PropTypes.string,
};

export default React.memo(StatusFilterButton);
